import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";

export const OcjeneDataTable = (props) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  return (
    <div className="centerText">
      <DataTable
        value={props.data}
        stripedRows
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
        responsiveLayout="scroll"
      >
        <Column
          field="datum"
          header="Datum"
          className="table-column-date"
        ></Column>
        <Column
          field="naziv_predmeta"
          header="Predmet"
          className="table-column-default"
        ></Column>
        <Column
          field="biljeska"
          header="Bilješka"
          className="table-column-course"
        ></Column>
        <Column
          field="ocjena"
          header="Ocjena"
          className="table-column-grade"
        ></Column>
      </DataTable>
    </div>
  );
};

export default OcjeneDataTable;
